import get from 'lodash.get'

const ESC_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }
export const escHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ESC_MAP[c])
export const toNum = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }

export const DEFAULT_ALLOCATION_COLOR = 'rgba(0, 153, 255, 1)'
export const DEFAULT_OOT_COLOR = 'rgba(220, 38, 38, 0.85)'
export const DEFAULT_TARGET_COLOR = 'rgba(0, 0, 80, 0.8)'
export const DEFAULT_THRESHOLD_COLOR = 'rgba(0, 0, 0, 0.7)'

/**
 * Resolves a tooltip template string against an item's data.
 * Uses the same {token} pattern as charts/echarts/Tooltip.jsx formatTemplate,
 * but resolves against the chart item fields (name, actual, target, etc.)
 * rather than ECharts params. Numeric values are run through valueFormatter.
 */
export function resolveTooltipTemplate (template, item, valueFormatter) {
  return template.replace(/\{([^}]+)\}/g, (_, key) => {
    const val = item[key]
    if (val == null) return ''
    if (typeof val === 'number') return escHtml(valueFormatter(val))
    return escHtml(String(val))
  })
}

export function extractChartData (data, accessors) {
  const {
    seriesAccessor,
    nameAccessor,
    actualAccessor,
    targetAccessor,
    tolLowAccessor,
    tolHighAccessor,
    allocationColorAccessor
  } = accessors
  const items = get(data, seriesAccessor, data)
  if (!Array.isArray(items)) return []
  return items.map((item) => {
    const target = toNum(get(item, targetAccessor))
    const tolLowOffset = tolLowAccessor ? toNum(get(item, tolLowAccessor)) : null
    const tolHighOffset = tolHighAccessor ? toNum(get(item, tolHighAccessor)) : null

    const hasBand = tolLowOffset !== null && tolHighOffset !== null &&
      (tolLowOffset !== 0 || tolHighOffset !== 0)

    const actual = toNum(get(item, actualAccessor))
    const bandStart = hasBand ? Math.max(0, target + tolLowOffset) : null
    const bandEnd = hasBand ? Math.max(0, target + tolHighOffset) : null
    const isOOT = hasBand && (actual < bandStart || actual > bandEnd)

    return {
      name: get(item, nameAccessor) || '',
      actual,
      target,
      bandStart,
      bandEnd,
      isOOT,
      color: allocationColorAccessor ? get(item, allocationColorAccessor) || null : null
    }
  })
}

/**
 * Encodes extracted chart data into the flat array format the custom renderItem expects.
 * Each row: [index, actual, target, bandStart, bandEnd, isOOT]
 */
export function encodeSeriesData (chartData) {
  const reversed = [...chartData].reverse()
  return reversed.map((d, idx) => [
    idx,
    d.actual,
    d.target,
    d.bandStart ?? d.target,
    d.bandEnd ?? d.target,
    d.isOOT ? 1 : 0
  ])
}
